import { render, staticRenderFns } from "./item2.vue?vue&type=template&id=e9d775f8&scoped=true"
import script from "./item2.vue?vue&type=script&lang=js"
export * from "./item2.vue?vue&type=script&lang=js"
import style0 from "./item2.vue?vue&type=style&index=0&id=e9d775f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d775f8",
  null
  
)

export default component.exports